import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Route } from 'react-router-dom'

import { CssBaseline, Container } from '@material-ui/core'

import Login from '../pages/Login'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  }
}))

const DefaultLayout: React.FC<RouteComponentProps> = ({ match }) => {
  const classes = useStyles({})

  return (
    <React.Fragment>
      <CssBaseline />
      <Container component="main" maxWidth="xs" className={classes.container}>
        <Route exact path={`${match.path}/login`} component={Login} />
      </Container>
    </React.Fragment>
  )
}

export default DefaultLayout
